import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

// The builds that get marked. Anything else (unset, empty, "prod", a typo)
// shows nothing, so a deploy that forgets the variable is a clean production
// build, never a marked one.
const ENVIRONMENTS = ['local', 'dev', 'cleanroom'];

export const environmentOf = (raw) => {
  const env = (raw || '').trim().toLowerCase();
  return ENVIRONMENTS.includes(env) ? env : null;
};

/**
 * Says which environment this build belongs to (MI-233): a small tab hanging
 * from the top edge of the window on every page, so dev is never mistaken for
 * production. `REACT_APP_ENV` is set per target in `.env.*` and, on Railway, as
 * a service variable on dev only.
 */
export default function EnvBadge({ env = process.env.REACT_APP_ENV }) {
  const { t } = useTranslation('common');
  const key = environmentOf(env);
  if (!key) return null;

  return (
    <Box
      position="fixed"
      top="env(safe-area-inset-top, 0px)"
      left="50%"
      transform="translateX(-50%)"
      zIndex={1600}
      px="7px"
      h="12px"
      display="flex"
      alignItems="center"
      borderBottomRadius="5px"
      bg="redesign.env.bg"
      color="redesign.env.fg"
      fontSize="8px"
      fontWeight="700"
      letterSpacing="0.1em"
      textTransform="uppercase"
      lineHeight="1"
      whiteSpace="nowrap"
      pointerEvents="none"
      userSelect="none"
      data-testid="env-badge"
    >
      {t(`env.${key}`)}
    </Box>
  );
}
